import React from "react";
import { useNavigate } from "react-router-dom";
import MainMenuItem from "app/components/MainMenuItem";
import Path from "app/route/Path";

function ScalpDataMenuItem(props) {
  const navigate = useNavigate();

  const onMenuItemClicked = () => {
    navigate(Path.scalpData);
  };

  return (
    <MainMenuItem
      itemTitleString="頭皮データ"
      onClick={onMenuItemClicked}
      size="100%"
    />
  );
}

export default ScalpDataMenuItem;
